export default __webpack_public_path__ + "static/media/explore5.0f47c826.png";